import TextInputWrapper from './TextInputWrapper'

export default TextInputWrapper
